import React from 'react';
import Modal from '../../../../components/modal';
import Button from '../../../../components/button/button';
import { Desktop, Mobile } from '../../../../app-responsive';
import { customStylesDesktop, customStylesMobile } from '../../../../components/business-case-delete-modal/modal-styles-config';
import PopupHeader from '../popup-header/popup-header';

const RequestCallBackModalOnline = (props) => {
  const {
    modalIsOpen,
    onCloseDialogBox,
    onRequestCallback,
    onStartLiveChat,
    authorableContent,
    callBackRequestCompleted,
  } = props;

  const {
    liveChatModalTitle,
    liveChatModalText,
    callBackButtontext,
    chatNowButtonText,
    callbackThankYouTitle,
    callbackThankYouText,
  } = authorableContent;
  const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '50%' } };

  const modalContent = customStyles => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onCloseDialogBox}
      style={customStyles}
    >
      {callBackRequestCompleted === false &&
      <div className="request-callback-offline-modal text-center">
        <PopupHeader PopTitle={liveChatModalTitle} PopupText={liveChatModalText} />
        <div className="row action-block online-action">
          <Button
            className="col-lg-3"
            buttonText={callBackButtontext}
            onClick={onRequestCallback}
          />
          <Button
            className="col-lg-3 secound-btn"
            buttonText={chatNowButtonText}
            onClick={onStartLiveChat}
          />
        </div>
      </div>
      }
      {callBackRequestCompleted &&
        <div className="request-callback-offline-modal text-center">
          <PopupHeader PopTitle={callbackThankYouTitle} PopupText={callbackThankYouText} />
        </div>
      }
    </Modal>
  );
  return (
    <React.Fragment>
      <Mobile>
        {modalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default RequestCallBackModalOnline;
